import type { StateCreator } from 'zustand';
import { DEFAULT_CONSULTATION_FIELDS } from './constants';
import type { ConsultationsSliceType } from './types';

export const setConsultationField: StateCreator<
  ConsultationsSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  ConsultationsSliceType['setConsultationField']
> = (set) => {
  return (consultationId, fieldName, value) => {
    set(
      (state) => {
        if (!state.consultations[consultationId]) {
          state.consultations[consultationId] = { ...DEFAULT_CONSULTATION_FIELDS };
        }
        state.consultations[consultationId][fieldName] = value;
      },
      false,
      'consultations/setConsultationField',
    );
  };
};

export const getConsultationField: StateCreator<
  ConsultationsSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  ConsultationsSliceType['getConsultationField']
> = (_set, get) => {
  return (consultationId, fieldName) => {
    const state = get();
    const consultationFields = state.consultations[consultationId];
    const result = consultationFields?.[fieldName];

    return result;
  };
};

export const getConsultationFields: StateCreator<
  ConsultationsSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  ConsultationsSliceType['getConsultationFields']
> = (_set, get) => {
  return (consultationId) => {
    const state = get();
    const result = state.consultations[consultationId];

    return result;
  };
};

export const resetConsultation: StateCreator<
  ConsultationsSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  ConsultationsSliceType['resetConsultation']
> = (set) => {
  return (consultationId) => {
    set(
      (state) => {
        delete state.consultations[consultationId];
      },
      false,
      'consultations/resetConsultation',
    );
  };
};

export const resetAllConsultations: StateCreator<
  ConsultationsSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  ConsultationsSliceType['resetAllConsultations']
> = (set) => {
  return () => {
    set(
      (state) => {
        state.consultations = {};
      },
      false,
      'consultations/resetAllConsultations',
    );
  };
};
